import { MultiPolygonWithHoles, PolygonWithHoles } from "@nova/constants"
import type { Position } from "geojson"

export function polygonWithHolesToGeoJSON(polygon: PolygonWithHoles) {
    const toPosition = ({
        longitude,
        latitude,
    }: {
        longitude: number
        latitude: number
    }): Position => [longitude, latitude]
    return {
        type: "Polygon" as const,
        coordinates: [
            polygon.outer.map(toPosition),
            ...polygon.holes.map((hole) => hole.map(toPosition)),
        ],
    }
}

export function multiPolygonWithHolesToGeoJSON(multiPolygon: MultiPolygonWithHoles) {
    if (multiPolygon.length === 1) return polygonWithHolesToGeoJSON(multiPolygon[0])
    return {
        type: "MultiPolygon" as const,
        coordinates: multiPolygon.map((piece) => polygonWithHolesToGeoJSON(piece).coordinates),
    }
}
